// Copyright (c) Docugami, Inc. All rights reserved.

import { AuthenticationState, SET_LOGIN_URL, SET_ERROR_ENOUNTERED, SET_USER_ROLES_PER_ORG } from "./types";
import { AnyAction } from "@reduxjs/toolkit";

const initialState: AuthenticationState = {
    loginUrl: '',
    errorEncountered: false,
    userRolesPerOrg: undefined
};

export function authenticationReducer(
    state = initialState,
    action: AnyAction
): AuthenticationState
{
    switch (action.type)
    {
        case SET_LOGIN_URL:
        {
            return {
                ...state,
                loginUrl: action.payload
            }
        }

        case SET_ERROR_ENOUNTERED:
        {
            return {
                ...state,
                errorEncountered: action.payload
            }
        }

        case SET_USER_ROLES_PER_ORG:
        {
            return {
                ...state,
                userRolesPerOrg: { ...action.payload }
            }
        }

        default:
            return state;
    }
}
